import React, { useState } from 'react';
import './App.css';
import Header from './components/header/Header';
import Home from './components/home/Home'
import About from './components/about/About'
import Skills from './components/skills/Skills';
import Qualification from './components/qualification/Qualification';
import Work from './components/work/Work';
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer';
import Scrollup from './components/scrollup/Scrollup';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const handleDarkModeToggle = () => {
    setIsDarkMode(!isDarkMode);
  };
  return (
    <>
        <Header onDarkModeToggle={handleDarkModeToggle} isDarkMode={isDarkMode} />

    <main className='main'>
      <Home isDarkMode={isDarkMode} /> 
      {/* use hero icons */}
      <About isDarkMode={isDarkMode}  />
      <Skills isDarkMode={isDarkMode} />
      <Qualification isDarkMode={isDarkMode} />
      <Work isDarkMode={isDarkMode}/>
      <Contact isDarkMode={isDarkMode}/>
    </main>

    <Footer isDarkMode={isDarkMode}/>
    <Scrollup isDarkMode={isDarkMode}/>
    </>
  );
}

export default App;
